<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(totalWeightIncludePack)="data">
        {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
      </template>
<!--      <template v-slot:cell(agreeWeight)="data">-->
<!--        {{ Number(data.item.agreeWeight).toFixed(4) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(totalPackWeight)="data">-->
<!--        {{ Number(data.item.totalPackWeight).toFixed(4) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(totalWeightExcludePack)="data">-->
<!--        {{ Number(data.item.totalWeightExcludePack).toFixed(4) }}-->
<!--      </template>-->

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(brandName)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
      </template>
      <template v-slot:foot(totalWeightIncludePack)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalWeightIncludePack') }}</div>
      </template>
      <template v-slot:foot(truckNum)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum3(items, 'truckNum') }}</div>
      </template>
<!--      <template v-slot:foot(totalPackWeight)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum2(items, 'totalPackWeight') }}</div>-->
<!--      </template>-->
<!--      <template v-slot:foot(totalWeightExcludePack)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum2(items, 'totalWeightExcludePack') }}</div>-->
<!--      </template>-->
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "ItsSalesDepartDetailNew",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel',  label: '产品等级', width: '120px'},
        {key: 'totalWeightIncludePack', label: '含筐总重（斤）', width: '120px'},
        {key: 'truckNum', label: '装车件数（筐）', width: '120px'},
        {key: 'packModel', label: '塑料筐规格', width: '120px'},
        // {key: 'agreeWeight', label: '包装材料约定重量（斤/件）', width: '140px'},
        // {key: 'totalPackWeight', label: '装车包装材料约定重量（斤）', width: '160px'},
        // {key: 'totalWeightExcludePack', label: '不含筐总重（斤）', width: '120px'},
      ],
      items: [],
      unitCategory: '',
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return new Decimal(0);
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return new Decimal(total);
      }, new Decimal(0)).toFixed(2, Decimal.ROUND_HALF_UP);
    },
    sumNum3(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return new Decimal(0);
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return new Decimal(total);
      }, new Decimal(0)).toFixed(0, Decimal.ROUND_HALF_UP);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return new Decimal(0);
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return new Decimal(total);
      }, new Decimal(0)).toFixed(4, Decimal.ROUND_HALF_UP);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
